import type { ChangeEvent } from "react";
import { useAppDispatch } from "../../redux";
import { ISRAELIID_LENGTHS } from "../../constants";
import type { IsraeliIdInputProps } from "../../types";
import { setIsraeliId } from "../RegistrationPage/RegistrationPageSlice";
import { TextField } from "@mui/material";

export default function IsraeliIdInput(props: IsraeliIdInputProps) {
  const { errors, label, helperText, israeliId, setErrors } = props;

  const dispatch = useAppDispatch();

  const handleIsraeliIdChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.currentTarget;

    if (!value || isNaN(Number(value))) return dispatch(setIsraeliId(null));

    if (!ISRAELIID_LENGTHS.includes(value.length)) setErrors({ ...errors, israeliId: true });
    else setErrors({ ...errors, israeliId: false });

    dispatch(setIsraeliId(value));
  };

  return (
    <TextField
      required
      fullWidth
      autoFocus
      type="tel"
      name="Israeli ID"
      autoComplete={"off"}
      value={israeliId ? israeliId : ""}
      onChange={handleIsraeliIdChange}
      error={!israeliId ? false : errors.israeliId}
      helperText={helperText}
      label={`${label} ${israeliId ? String(israeliId).length : 0} / 9`}
      inputProps={{ maxLength: 9 }}
    ></TextField>
  );
}
